import { BaseModel } from '@shared/base/Base.Model';
import { IWebSocketModel } from '@shared/interface/IWebSocketModel';
import { DateTimeNonMomentUtility } from '@shared/utility/DateTimeNonMoment.Utility';
import { WebSocketModelUtility } from '@shared/utility/WebSocketModel.Utility';

export interface ITimeModel {
    type: string;
    data: Date;
}

export class TimeModel extends BaseModel implements ITimeModel, IWebSocketModel {
    public static readonly expectedPacketType: string = 'time_case';

    public isIWebSocketModel: boolean = true;
    public packetType: string = null;
    public id: number = null;

    public type: string = null;
    public data: Date = null;

    public constructor() {
        super();
    }

    public loadFromWebSocketMessage(message: any): void {
        WebSocketModelUtility.loadProperties(message, this, 'RIFT-WS-TimeModel');

        this.data = DateTimeNonMomentUtility.fromRestApiDateTime(this.data);
    }

    public toWebSocketMessage(): any {
        return {
            ...WebSocketModelUtility.toJson(this),
        };
    }
}
